import { defineMessages, type MessageDescriptor } from 'react-intl';

import { Team } from '../types';

export const messages: {
	useCaseAcquireAndOnboardNewTalent: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseBrainstormAndExploreIdeas: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseCaptureMeetingNotesAndActions: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseCentralizeCodebaseAndProcessGuides: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseCentralizeMarketingInsightsAndGuides: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseCentralizeUserInsightsAndJourneys: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseConductWorkshopsAndReviews: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseCraftStrategiesAndRoadmaps: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseCreateTeamPlaybooks: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseDocumentDesignDecisionsAndFlows: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseDocumentIncidentsAndResolutions: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseDocumentMeetingsAndRunRetros: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseDocumentSopsAndWorkflows: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseDocumentTechSpecsAndDecisions: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseDraftMarketingContent: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseManageLeadsAndDeals: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCasePlanAndTrackCampaigns: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCasePlanAndTrackProjects: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCasePlanSprintsAndRunRetros: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseReportProgressAndPerformance: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseShareFinancialResultsAndPlans: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseShareHowToAndTroubleshootingDocs: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseShareHrPoliciesAndGuides: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseShareLegalTemplatesAndGuides: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseStoreTeamProceduresAndReferences: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateAnnualPlanOnePager: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateArchitectureDiagram: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateBrainstormSession: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateBusinessReview: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateBusinessStatusUpdate: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateCrazy8s: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateCustomerInterviewReport: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateDaciDecisionDocumentation: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateDesignDecision: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateDesignReview: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateDesignSprint: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateDevopsRunbook: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateElevatorPitchBrainstorm: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateExecutiveBusinessReview: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateFlowchart: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateHiringProcess: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateHowToArticle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateHrKnowledgeBase: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateIncidentPostmortem: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateItsmKnownErrors: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateItsmRunbook: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateMarketingBlogPost: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateMarketingCampaign: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateMeetingNotes: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateMessageHouse: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateMutualActionPlan: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateNinetyDayPlan: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateOkrs: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateOrganizationalChart: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplatePresenterMode: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateProductRequirements: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateProductRoadmap: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateProductVisionBoard: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateProjectPlan: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateRetrospective: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateRiskAssessment: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateSalesAccountPlanning: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateSalesPortal: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateSop: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateSprintPlanning: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateToDoList: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateTroubleshootingArticle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateUserPersona: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateVendorAgreement: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateWeeklyIncidentReport: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateWeeklyStatusReport: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTemplateWorkflow: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseTrackGoalsAndOkrs: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	useCaseWriteProductRequirements: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	useCasePlanAndTrackProjects: {
		id: 'confluence-account-setup.use-cases.plan-and-track-projects',
		defaultMessage: 'Plan and track projects 🗓️',
		description: 'Use Case description',
	},
	useCaseCaptureMeetingNotesAndActions: {
		id: 'confluence-account-setup.use-cases.capture-meeting-notes-and-actions',
		defaultMessage: 'Capture meeting notes and actions 📝',
		description: 'Use Case description',
	},
	useCaseBrainstormAndExploreIdeas: {
		id: 'confluence-account-setup.use-cases.brainstorm-and-explore-ideas',
		defaultMessage: 'Brainstorm and explore ideas 💡',
		description: 'Use Case description',
	},
	useCaseDocumentTechSpecsAndDecisions: {
		id: 'confluence-account-setup.use-cases.document-tech-specs-and-decisions',
		defaultMessage: 'Document tech specs and decisions 📝',
		description: 'Use Case description',
	},
	useCaseCentralizeCodebaseAndProcessGuides: {
		id: 'confluence-account-setup.use-cases.centralize-codebase-and-process-guides',
		defaultMessage: 'Centralize codebase and process guides 📚',
		description: 'Use Case description',
	},
	useCasePlanSprintsAndRunRetros: {
		id: 'confluence-account-setup.use-cases.plan-sprints-and-run-retros',
		defaultMessage: 'Plan sprints and run retros 🔁',
		description: 'Use Case description',
	},
	useCaseDocumentMeetingsAndRunRetros: {
		id: 'confluence-account-setup.use-cases.document-meetings-and-run-retros',
		defaultMessage: 'Document meetings and run retros 📝',
		description: 'Use Case description',
	},
	useCaseTrackGoalsAndOkrs: {
		id: 'confluence-account-setup.use-cases.track-goals-and-okrs',
		defaultMessage: 'Track goals and OKRs 🎯',
		description: 'Use Case description',
	},
	useCasePlanAndTrackCampaigns: {
		id: 'confluence-account-setup.use-cases.plan-and-track-campaigns',
		defaultMessage: 'Plan and track campaigns 📣',
		description: 'Use Case description',
	},
	useCaseDraftMarketingContent: {
		id: 'confluence-account-setup.use-cases.draft-marketing-content',
		defaultMessage: 'Draft marketing content 📝',
		description: 'Use Case description',
	},
	useCaseCentralizeMarketingInsightsAndGuides: {
		id: 'confluence-account-setup.use-cases.centralize-marketing-insights-and-guides',
		defaultMessage: 'Centralize marketing insights and guides 🏛️',
		description: 'Use Case description',
	},
	useCaseConductWorkshopsAndReviews: {
		id: 'confluence-account-setup.use-cases.conduct-workshops-and-reviews',
		defaultMessage: 'Conduct workshops and reviews 🗣️',
		description: 'Use Case description',
	},
	useCaseDocumentDesignDecisionsAndFlows: {
		id: 'confluence-account-setup.use-cases.document-design-decisions-and-flows',
		defaultMessage: 'Document design decisions and flows 🎨',
		description: 'Use Case description',
	},
	useCaseCentralizeUserInsightsAndJourneys: {
		id: 'confluence-account-setup.use-cases.centralize-user-insights-and-journeys',
		defaultMessage: 'Centralize user insights and journeys 🗂️',
		description: 'Use Case description',
	},
	useCaseWriteProductRequirements: {
		id: 'confluence-account-setup.use-cases.write-product-requirements',
		defaultMessage: 'Write product requirements 🧾',
		description: 'Use Case description',
	},
	useCaseCraftStrategiesAndRoadmaps: {
		id: 'confluence-account-setup.use-cases.craft-strategies-and-roadmaps',
		defaultMessage: 'Craft strategies and roadmaps 🗺️',
		description: 'Use Case description',
	},
	useCaseDocumentSopsAndWorkflows: {
		id: 'confluence-account-setup.use-cases.document-sops-and-workflows',
		defaultMessage: 'Document SOPs and workflows 📋',
		description: 'Use Case description',
	},
	useCaseShareHowToAndTroubleshootingDocs: {
		id: 'confluence-account-setup.use-cases.share-how-to-and-troubleshooting-docs',
		defaultMessage: 'Share how-to and troubleshooting docs 📚',
		description: 'Use Case description',
	},
	useCaseStoreTeamProceduresAndReferences: {
		id: 'confluence-account-setup.use-cases.store-team-procedures-and-references',
		defaultMessage: 'Store team procedures and references 📋',
		description: 'Use Case description',
	},
	useCaseDocumentIncidentsAndResolutions: {
		id: 'confluence-account-setup.use-cases.document-incidents-and-resolutions',
		defaultMessage: 'Document incidents and resolutions 🛠️',
		description: 'Use Case description',
	},
	useCaseShareFinancialResultsAndPlans: {
		id: 'confluence-account-setup.use-cases.share-financial-results-and-plans',
		defaultMessage: 'Share financial results and plans 📊',
		description: 'Use Case description',
	},
	useCaseShareHrPoliciesAndGuides: {
		id: 'confluence-account-setup.use-cases.share-hr-policies-and-guides',
		defaultMessage: 'Share HR policies and guides 📖',
		description: 'Use Case: Share HR policies and guides ',
	},
	useCaseAcquireAndOnboardNewTalent: {
		id: 'confluence-account-setup.use-cases.acquire-and-onboard-new-talent',
		defaultMessage: 'Acquire and onboard new talent 👤',
		description: 'Use Case: Acquire and onboard new talent ',
	},
	useCaseShareLegalTemplatesAndGuides: {
		id: 'confluence-account-setup.use-cases.share-legal-templates-and-guides',
		defaultMessage: 'Share legal templates and guides 💬',
		description: 'Use Case description',
	},
	useCaseCreateTeamPlaybooks: {
		id: 'confluence-account-setup.use-cases.create-team-playbooks',
		defaultMessage: 'Create team playbooks 📖',
		description: 'Use Case description',
	},
	useCaseManageLeadsAndDeals: {
		id: 'confluence-account-setup.use-cases.manage-leads-and-deals',
		defaultMessage: 'Manage leads and deals 🗂️',
		description: 'Use Case description',
	},
	useCaseReportProgressAndPerformance: {
		id: 'confluence-account-setup.use-cases.report-progress-and-performance',
		defaultMessage: 'Report progress and performance 📈',
		description: 'Use Case description',
	},
	useCaseTemplateProjectPlan: {
		id: 'confluence-account-setup.use-cases.templates.project-plan',
		defaultMessage: 'Project Plan',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateWeeklyStatusReport: {
		id: 'confluence-account-setup.use-cases.templates.weekly-status-report',
		defaultMessage: 'Weekly status report',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateMeetingNotes: {
		id: 'confluence-account-setup.use-cases.templates.meeting-notes',
		defaultMessage: 'Meeting Notes',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateToDoList: {
		id: 'confluence-account-setup.use-cases.templates.to-do-list',
		defaultMessage: 'To-do list',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateCrazy8s: {
		id: 'confluence-account-setup.use-cases.templates.crazy-8s',
		defaultMessage: 'Crazy 8s',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateBrainstormSession: {
		id: 'confluence-account-setup.use-cases.templates.brainstorm-session',
		defaultMessage: 'Brainstorm session',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateFlowchart: {
		id: 'confluence-account-setup.use-cases.templates.flowchart',
		defaultMessage: 'Flowchart',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateDaciDecisionDocumentation: {
		id: 'confluence-account-setup.use-cases.templates.daci-decision-documentation',
		defaultMessage: 'DACI: Decision Documentation',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateArchitectureDiagram: {
		id: 'confluence-account-setup.use-cases.templates.architecture-diagram',
		defaultMessage: 'Architecture diagram',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateDevopsRunbook: {
		id: 'confluence-account-setup.use-cases.templates.devops-runbook',
		defaultMessage: 'DevOps Runbook',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateSprintPlanning: {
		id: 'confluence-account-setup.use-cases.templates.sprint-planning',
		defaultMessage: 'Sprint planning',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateRetrospective: {
		id: 'confluence-account-setup.use-cases.templates.retrospective',
		defaultMessage: 'Retrospective',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateOkrs: {
		id: 'confluence-account-setup.use-cases.templates.okrs',
		defaultMessage: 'OKRs',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateBusinessReview: {
		id: 'confluence-account-setup.use-cases.templates.business-review',
		defaultMessage: 'Business review',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateMarketingCampaign: {
		id: 'confluence-account-setup.use-cases.templates.marketing-campaign',
		defaultMessage: 'Marketing Campaign',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateBusinessStatusUpdate: {
		id: 'confluence-account-setup.use-cases.templates.business-status-update',
		defaultMessage: 'Business status update',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateMarketingBlogPost: {
		id: 'confluence-account-setup.use-cases.templates.marketing-blog-post',
		defaultMessage: 'Marketing blog post',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateElevatorPitchBrainstorm: {
		id: 'confluence-account-setup.use-cases.templates.elevator-pitch-brainstorm',
		defaultMessage: 'Elevator pitch brainstorm',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateMessageHouse: {
		id: 'confluence-account-setup.use-cases.templates.message-house',
		defaultMessage: 'Message house',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateUserPersona: {
		id: 'confluence-account-setup.use-cases.templates.user-persona',
		defaultMessage: 'User Persona',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateDesignReview: {
		id: 'confluence-account-setup.use-cases.templates.design-review',
		defaultMessage: 'Design Review',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateDesignSprint: {
		id: 'confluence-account-setup.use-cases.templates.design-sprint',
		defaultMessage: 'Design Sprint',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateDesignDecision: {
		id: 'confluence-account-setup.use-cases.templates.design-decision',
		defaultMessage: 'Design decision',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateCustomerInterviewReport: {
		id: 'confluence-account-setup.use-cases.templates.customer-interview-report',
		defaultMessage: 'Customer interview report',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateProductRequirements: {
		id: 'confluence-account-setup.use-cases.templates.product-requirements',
		defaultMessage: 'Product Requirements',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateProductRoadmap: {
		id: 'confluence-account-setup.use-cases.templates.product-roadmap',
		defaultMessage: 'Product roadmap',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateProductVisionBoard: {
		id: 'confluence-account-setup.use-cases.templates.product-vision-board',
		defaultMessage: 'Product Vision Board',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateSop: {
		id: 'confluence-account-setup.use-cases.templates.sop',
		defaultMessage: 'SOP',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateWorkflow: {
		id: 'confluence-account-setup.use-cases.templates.workflow',
		defaultMessage: 'Workflow',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateHowToArticle: {
		id: 'confluence-account-setup.use-cases.templates.how-to-article',
		defaultMessage: 'How-to article',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateTroubleshootingArticle: {
		id: 'confluence-account-setup.use-cases.templates.troubleshooting-article',
		defaultMessage: 'Troubleshooting article',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateItsmRunbook: {
		id: 'confluence-account-setup.use-cases.templates.itsm-runbook',
		defaultMessage: 'ITSM runbook',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateItsmKnownErrors: {
		id: 'confluence-account-setup.use-cases.templates.itsm-known-errors',
		defaultMessage: 'ITSM Known Errors',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateIncidentPostmortem: {
		id: 'confluence-account-setup.use-cases.templates.incident-postmortem',
		defaultMessage: 'Incident Postmortem',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateWeeklyIncidentReport: {
		id: 'confluence-account-setup.use-cases.templates.weekly-incident-report',
		defaultMessage: 'Weekly incident report',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateAnnualPlanOnePager: {
		id: 'confluence-account-setup.use-cases.templates.annual-plan-one-pager',
		defaultMessage: 'Annual Plan One Pager',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateHrKnowledgeBase: {
		id: 'confluence-account-setup.use-cases.templates.hr-knowledge-base',
		defaultMessage: 'HR Knowledge Base',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateOrganizationalChart: {
		id: 'confluence-account-setup.use-cases.templates.organizational-chart',
		defaultMessage: 'Organizational chart',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateHiringProcess: {
		id: 'confluence-account-setup.use-cases.templates.hiring-process',
		defaultMessage: 'Hiring Process',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateNinetyDayPlan: {
		id: 'confluence-account-setup.use-cases.templates.90-day-plan',
		defaultMessage: '90 Day Plan',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateVendorAgreement: {
		id: 'confluence-account-setup.use-cases.templates.vendor-agreement',
		defaultMessage: 'Vendor Agreement',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateRiskAssessment: {
		id: 'confluence-account-setup.use-cases.templates.risk-assessment',
		defaultMessage: 'Risk Assessment',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateSalesPortal: {
		id: 'confluence-account-setup.use-cases.templates.sales-portal',
		defaultMessage: 'Sales Portal',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateSalesAccountPlanning: {
		id: 'confluence-account-setup.use-cases.templates.sales-account-planning',
		defaultMessage: 'Sales Account Planning',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateMutualActionPlan: {
		id: 'confluence-account-setup.use-cases.templates.mutual-action-plan',
		defaultMessage: 'Mutual Action Plan',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplateExecutiveBusinessReview: {
		id: 'confluence-account-setup.use-cases.templates.executive-business-review',
		defaultMessage: 'Executive Business Review',
		description: 'Template recomended by Use Cases screen',
	},
	useCaseTemplatePresenterMode: {
		id: 'confluence-account-setup.use-cases.templates.presenter-mode',
		defaultMessage: 'Presenter mode',
		description: 'Template recomended by Use Cases screen',
	},
});

export enum UseCaseTemplate {
	NinetyDayPlan = 'ninety-day-plan',
	AnnualPlanOnePager = 'annual-plan-one-pager',
	ArchitectureDiagram = 'architecture-diagram',
	BrainstormSession = 'brainstorm-session',
	BusinessReview = 'business-review',
	BusinessStatusUpdate = 'business-status-update',
	Crazy8s = 'crazy-8s', // Whiteboard
	CustomerInterviewReport = 'customer-interview-report',
	DaciDecisionDocumentation = 'daci-decision-documentation',
	DesignDecision = 'design-decision',
	DesignReview = 'design-review',
	DesignSprint = 'design-sprint',
	DevopsRunbook = 'devops-runbook',
	ElevatorPitchBrainstorm = 'elevator-pitch', // Whiteboard
	ExecutiveBusinessReview = 'executive-business-review',
	Flowchart = 'flow-chart', // Whiteboard
	HiringProcess = 'hiring-process',
	HowToArticle = 'how-to-article',
	HrKnowledgeBase = 'hr-knowledge-base',
	IncidentPostmortem = 'incident-postmortem',
	ItsmKnownErrors = 'itsm-known-errors',
	ItsmRunbook = 'itsm-runbook',
	MarketingBlogPost = 'marketing-blog-post',
	MarketingCampaign = 'marketing-campaign',
	MeetingNotes = 'meeting-notes',
	MessageHouse = 'message-house',
	MutualActionPlan = 'mutual-action-plan',
	Okrs = 'okrs',
	OrganizationalChart = 'org-chart', // Whiteboard
	PresenterMode = 'presenter-mode',
	ProductRequirements = 'product-requirements',
	ProductRoadmap = 'product-roadmap',
	ProductVisionBoard = 'product-vision-board', // Whiteboard
	ProjectPlan = 'project-plan',
	Retrospective = 'simple-retrospective', // Whiteboard
	RiskAssessment = 'risk-assessment',
	SalesAccountPlanning = 'sales-account-planning',
	SalesPortal = 'sales-portal',
	Sop = 'sop',
	SprintPlanning = 'sprint-planning',
	ToDoList = 'to-do-list',
	TroubleshootingArticle = 'troubleshooting-article',
	UserPersona = 'user-persona',
	VendorAgreement = 'vendor-agreement',
	WeeklyIncidentReport = 'weekly-incident-report',
	WeeklyStatusReport = 'weekly-status-report',
	Workflow = 'workflow', // Whiteboard
}

export type UseCaseTemplateDataType = {
	id: UseCaseTemplate;
	nameDescriptor: MessageDescriptor;
	templateId: string;
	templateType: 'page' | 'whiteboard';
};

export enum UseCase {
	PlanAndTrackProjects = 'plan-and-track-projects',
	CaptureMeetingNotesAndActions = 'capture-meeting-notes-and-actions',
	BrainstormAndExploreIdeas = 'brainstorm-and-explore-ideas',
	DocumentTechSpecsAndDecisions = 'document-tech-specs-and-decisions',
	CentralizeCodebaseAndProcessGuides = 'centralize-codebase-and-process-guides',
	PlanSprintsAndRunRetros = 'plan-sprints-and-run-retros',
	DocumentMeetingsAndRunRetros = 'document-meetings-and-run-retros',
	TrackGoalsAndOkrs = 'track-goals-and-okrs',
	PlanAndTrackCampaigns = 'plan-and-track-campaigns',
	DraftMarketingContent = 'draft-marketing-content',
	CentralizeMarketingInsightsAndGuides = 'centralize-marketing-insights-and-guides',
	ConductWorkshopsAndReviews = 'conduct-workshops-and-reviews',
	DocumentDesignDecisionsAndFlows = 'document-design-decisions-and-flows',
	CentralizeUserInsightsAndJourneys = 'centralize-user-insights-and-journeys',
	WriteProductRequirements = 'write-product-requirements',
	CraftStrategiesAndRoadmaps = 'craft-strategies-and-roadmaps',
	DocumentSopsAndWorkflows = 'document-sops-and-workflows',
	ShareHowToAndTroubleshootingDocs = 'share-how-to-and-troubleshooting-docs',
	StoreTeamProceduresAndReferences = 'store-team-procedures-and-references',
	DocumentIncidentsAndResolutions = 'document-incidents-and-resolutions',
	ShareFinancialResultsAndPlans = 'share-financial-results-and-plans',
	ShareHrPoliciesAndGuides = 'share-hr-policies-and-guides',
	AcquireAndOnboardNewTalent = 'acquire-and-onboard-new-talent',
	ShareLegalTemplatesAndGuides = 'share-legal-templates-and-guides',
	CreateTeamPlaybooks = 'create-team-playbooks',
	ManageLeadsAndDeals = 'manage-leads-and-deals',
	ReportProgressAndPerformance = 'report-progress-and-performance',
}

export type UseCaseDataType = {
	id: UseCase;
	nameDescriptor: MessageDescriptor;
	templates: UseCaseTemplateDataType[];
};

const teamTypeToUseCaseMap: {
	[key in Team]: UseCaseDataType[];
} = {
	[Team.Other]: [
		{
			id: UseCase.PlanAndTrackProjects,
			nameDescriptor: messages.useCasePlanAndTrackProjects,
			templates: [
				{
					id: UseCaseTemplate.ProjectPlan,
					nameDescriptor: messages.useCaseTemplateProjectPlan,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.WeeklyStatusReport,
					nameDescriptor: messages.useCaseTemplateWeeklyStatusReport,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.CaptureMeetingNotesAndActions,
			nameDescriptor: messages.useCaseCaptureMeetingNotesAndActions,
			templates: [
				{
					id: UseCaseTemplate.MeetingNotes,
					nameDescriptor: messages.useCaseTemplateMeetingNotes,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.ToDoList,
					nameDescriptor: messages.useCaseTemplateToDoList,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.BrainstormAndExploreIdeas,
			nameDescriptor: messages.useCaseBrainstormAndExploreIdeas,
			templates: [
				{
					id: UseCaseTemplate.Crazy8s,
					nameDescriptor: messages.useCaseTemplateCrazy8s,
					templateId: 'crazy-8s',
					templateType: 'whiteboard',
				},
				{
					id: UseCaseTemplate.BrainstormSession,
					nameDescriptor: messages.useCaseTemplateBrainstormSession,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:disrupt-brainstorming-blueprint',
					templateType: 'page',
				},
			],
		},
	],
	[Team.SoftwareDevelopment]: [
		{
			id: UseCase.DocumentTechSpecsAndDecisions,
			nameDescriptor: messages.useCaseDocumentTechSpecsAndDecisions,
			templates: [
				{
					id: UseCaseTemplate.Flowchart,
					nameDescriptor: messages.useCaseTemplateFlowchart,
					templateId: 'flow-chart',
					templateType: 'whiteboard',
				},
				{
					id: UseCaseTemplate.DaciDecisionDocumentation,
					nameDescriptor: messages.useCaseTemplateDaciDecisionDocumentation,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.CentralizeCodebaseAndProcessGuides,
			nameDescriptor: messages.useCaseCentralizeCodebaseAndProcessGuides,
			templates: [
				{
					id: UseCaseTemplate.ArchitectureDiagram,
					nameDescriptor: messages.useCaseTemplateArchitectureDiagram,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.DevopsRunbook,
					nameDescriptor: messages.useCaseTemplateDevopsRunbook,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:devops-runbook-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.PlanSprintsAndRunRetros,
			nameDescriptor: messages.useCasePlanSprintsAndRunRetros,
			templates: [
				{
					id: UseCaseTemplate.SprintPlanning,
					nameDescriptor: messages.useCaseTemplateSprintPlanning,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.Retrospective,
					nameDescriptor: messages.useCaseTemplateRetrospective,
					templateId: 'simple-retrospective',
					templateType: 'whiteboard',
				},
			],
		},
	],
	[Team.ProjectManagement]: [
		{
			id: UseCase.PlanAndTrackProjects,
			nameDescriptor: messages.useCasePlanAndTrackProjects,
			templates: [
				{
					id: UseCaseTemplate.ProjectPlan,
					nameDescriptor: messages.useCaseTemplateProjectPlan,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.WeeklyStatusReport,
					nameDescriptor: messages.useCaseTemplateWeeklyStatusReport,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.DocumentMeetingsAndRunRetros,
			nameDescriptor: messages.useCaseDocumentMeetingsAndRunRetros,
			templates: [
				{
					id: UseCaseTemplate.Retrospective,
					nameDescriptor: messages.useCaseTemplateRetrospective,
					templateId: 'simple-retrospective',
					templateType: 'whiteboard',
				},
				{
					id: UseCaseTemplate.MeetingNotes,
					nameDescriptor: messages.useCaseTemplateMeetingNotes,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.TrackGoalsAndOkrs,
			nameDescriptor: messages.useCaseTrackGoalsAndOkrs,
			templates: [
				{
					id: UseCaseTemplate.Okrs,
					nameDescriptor: messages.useCaseTemplateOkrs,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:okr-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.BusinessReview,
					nameDescriptor: messages.useCaseTemplateBusinessReview,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint',
					templateType: 'page',
				},
			],
		},
	],
	[Team.Marketing]: [
		{
			id: UseCase.PlanAndTrackCampaigns,
			nameDescriptor: messages.useCasePlanAndTrackCampaigns,
			templates: [
				{
					id: UseCaseTemplate.MarketingCampaign,
					nameDescriptor: messages.useCaseTemplateMarketingCampaign,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.BusinessStatusUpdate,
					nameDescriptor: messages.useCaseTemplateBusinessStatusUpdate,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.DraftMarketingContent,
			nameDescriptor: messages.useCaseDraftMarketingContent,
			templates: [
				{
					id: UseCaseTemplate.MarketingBlogPost,
					nameDescriptor: messages.useCaseTemplateMarketingBlogPost,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blog-post-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.ElevatorPitchBrainstorm,
					nameDescriptor: messages.useCaseTemplateElevatorPitchBrainstorm,
					templateId: 'elevator-pitch',
					templateType: 'whiteboard',
				},
			],
		},
		{
			id: UseCase.CentralizeMarketingInsightsAndGuides,
			nameDescriptor: messages.useCaseCentralizeMarketingInsightsAndGuides,
			templates: [
				{
					id: UseCaseTemplate.MessageHouse,
					nameDescriptor: messages.useCaseTemplateMessageHouse,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:message-house-template-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.UserPersona,
					nameDescriptor: messages.useCaseTemplateUserPersona,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-blueprint',
					templateType: 'page',
				},
			],
		},
	],
	[Team.Design]: [
		{
			id: UseCase.ConductWorkshopsAndReviews,
			nameDescriptor: messages.useCaseConductWorkshopsAndReviews,
			templates: [
				{
					id: UseCaseTemplate.DesignReview,
					nameDescriptor: messages.useCaseTemplateDesignReview,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:design-review-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.DesignSprint,
					nameDescriptor: messages.useCaseTemplateDesignSprint,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.DocumentDesignDecisionsAndFlows,
			nameDescriptor: messages.useCaseDocumentDesignDecisionsAndFlows,
			templates: [
				{
					id: UseCaseTemplate.DesignDecision,
					nameDescriptor: messages.useCaseTemplateDesignDecision,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.Flowchart,
					nameDescriptor: messages.useCaseTemplateFlowchart,
					templateId: 'flow-chart',
					templateType: 'whiteboard',
				},
			],
		},
		{
			id: UseCase.CentralizeUserInsightsAndJourneys,
			nameDescriptor: messages.useCaseCentralizeUserInsightsAndJourneys,
			templates: [
				{
					id: UseCaseTemplate.UserPersona,
					nameDescriptor: messages.useCaseTemplateUserPersona,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.CustomerInterviewReport,
					nameDescriptor: messages.useCaseTemplateCustomerInterviewReport,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-interview-report-blueprint',
					templateType: 'page',
				},
			],
		},
	],
	[Team.ProductManagement]: [
		{
			id: UseCase.WriteProductRequirements,
			nameDescriptor: messages.useCaseWriteProductRequirements,
			templates: [
				{
					id: UseCaseTemplate.ProductRequirements,
					nameDescriptor: messages.useCaseTemplateProductRequirements,
					templateId:
						'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.DaciDecisionDocumentation,
					nameDescriptor: messages.useCaseTemplateDaciDecisionDocumentation,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.CraftStrategiesAndRoadmaps,
			nameDescriptor: messages.useCaseCraftStrategiesAndRoadmaps,
			templates: [
				{
					id: UseCaseTemplate.ProductRoadmap,
					nameDescriptor: messages.useCaseTemplateProductRoadmap,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.ProductVisionBoard,
					nameDescriptor: messages.useCaseTemplateProductVisionBoard,
					templateId: 'product-vision-board',
					templateType: 'whiteboard',
				},
			],
		},
		{
			id: UseCase.CaptureMeetingNotesAndActions,
			nameDescriptor: messages.useCaseCaptureMeetingNotesAndActions,
			templates: [
				{
					id: UseCaseTemplate.MeetingNotes,
					nameDescriptor: messages.useCaseTemplateMeetingNotes,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.ToDoList,
					nameDescriptor: messages.useCaseTemplateToDoList,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
					templateType: 'page',
				},
			],
		},
	],
	[Team.Operations]: [
		{
			id: UseCase.DocumentSopsAndWorkflows,
			nameDescriptor: messages.useCaseDocumentSopsAndWorkflows,
			templates: [
				{
					id: UseCaseTemplate.Sop,
					nameDescriptor: messages.useCaseTemplateSop,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.Workflow,
					nameDescriptor: messages.useCaseTemplateWorkflow,
					templateId: 'workflow',
					templateType: 'whiteboard',
				},
			],
		},
		{
			id: UseCase.TrackGoalsAndOkrs,
			nameDescriptor: messages.useCaseTrackGoalsAndOkrs,
			templates: [
				{
					id: UseCaseTemplate.Okrs,
					nameDescriptor: messages.useCaseTemplateOkrs,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:okr-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.BusinessReview,
					nameDescriptor: messages.useCaseTemplateBusinessReview,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.PlanAndTrackProjects,
			nameDescriptor: messages.useCasePlanAndTrackProjects,
			templates: [
				{
					id: UseCaseTemplate.ProjectPlan,
					nameDescriptor: messages.useCaseTemplateProjectPlan,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.WeeklyStatusReport,
					nameDescriptor: messages.useCaseTemplateWeeklyStatusReport,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
					templateType: 'page',
				},
			],
		},
	],
	[Team.ITSupport]: [
		{
			id: UseCase.ShareHowToAndTroubleshootingDocs,
			nameDescriptor: messages.useCaseShareHowToAndTroubleshootingDocs,
			templates: [
				{
					id: UseCaseTemplate.HowToArticle,
					nameDescriptor: messages.useCaseTemplateHowToArticle,
					templateId:
						'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.TroubleshootingArticle,
					nameDescriptor: messages.useCaseTemplateTroubleshootingArticle,
					templateId:
						'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.StoreTeamProceduresAndReferences,
			nameDescriptor: messages.useCaseStoreTeamProceduresAndReferences,
			templates: [
				{
					id: UseCaseTemplate.ItsmRunbook,
					nameDescriptor: messages.useCaseTemplateItsmRunbook,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.ItsmKnownErrors,
					nameDescriptor: messages.useCaseTemplateItsmKnownErrors,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.DocumentIncidentsAndResolutions,
			nameDescriptor: messages.useCaseDocumentIncidentsAndResolutions,
			templates: [
				{
					id: UseCaseTemplate.IncidentPostmortem,
					nameDescriptor: messages.useCaseTemplateIncidentPostmortem,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-management-post-mortem-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.WeeklyIncidentReport,
					nameDescriptor: messages.useCaseTemplateWeeklyIncidentReport,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-weekly-major-incident-report-blueprint',
					templateType: 'page',
				},
			],
		},
	],
	[Team.Finance]: [
		{
			id: UseCase.ShareFinancialResultsAndPlans,
			nameDescriptor: messages.useCaseShareFinancialResultsAndPlans,
			templates: [
				{
					id: UseCaseTemplate.BusinessStatusUpdate,
					nameDescriptor: messages.useCaseTemplateBusinessStatusUpdate,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.AnnualPlanOnePager,
					nameDescriptor: messages.useCaseTemplateAnnualPlanOnePager,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:annual-plan-one-pager-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.CaptureMeetingNotesAndActions,
			nameDescriptor: messages.useCaseCaptureMeetingNotesAndActions,
			templates: [
				{
					id: UseCaseTemplate.MeetingNotes,
					nameDescriptor: messages.useCaseTemplateMeetingNotes,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.ToDoList,
					nameDescriptor: messages.useCaseTemplateToDoList,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.PlanAndTrackProjects,
			nameDescriptor: messages.useCasePlanAndTrackProjects,
			templates: [
				{
					id: UseCaseTemplate.ProjectPlan,
					nameDescriptor: messages.useCaseTemplateProjectPlan,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.WeeklyStatusReport,
					nameDescriptor: messages.useCaseTemplateWeeklyStatusReport,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
					templateType: 'page',
				},
			],
		},
	],
	[Team.HumanResources]: [
		{
			id: UseCase.ShareHrPoliciesAndGuides,
			nameDescriptor: messages.useCaseShareHrPoliciesAndGuides,
			templates: [
				{
					id: UseCaseTemplate.HrKnowledgeBase,
					nameDescriptor: messages.useCaseTemplateHrKnowledgeBase,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:hr-knowledge-base-management-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.OrganizationalChart,
					nameDescriptor: messages.useCaseTemplateOrganizationalChart,
					templateId: 'org-chart',
					templateType: 'whiteboard',
				},
			],
		},
		{
			id: UseCase.PlanAndTrackProjects,
			nameDescriptor: messages.useCasePlanAndTrackProjects,
			templates: [
				{
					id: UseCaseTemplate.ProjectPlan,
					nameDescriptor: messages.useCaseTemplateProjectPlan,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.WeeklyStatusReport,
					nameDescriptor: messages.useCaseTemplateWeeklyStatusReport,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.AcquireAndOnboardNewTalent,
			nameDescriptor: messages.useCaseAcquireAndOnboardNewTalent,
			templates: [
				{
					id: UseCaseTemplate.HiringProcess,
					nameDescriptor: messages.useCaseTemplateHiringProcess,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.NinetyDayPlan,
					nameDescriptor: messages.useCaseTemplateNinetyDayPlan,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-blueprint',
					templateType: 'page',
				},
			],
		},
	],
	[Team.Legal]: [
		{
			id: UseCase.PlanAndTrackProjects,
			nameDescriptor: messages.useCasePlanAndTrackProjects,
			templates: [
				{
					id: UseCaseTemplate.ProjectPlan,
					nameDescriptor: messages.useCaseTemplateProjectPlan,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.WeeklyStatusReport,
					nameDescriptor: messages.useCaseTemplateWeeklyStatusReport,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.CaptureMeetingNotesAndActions,
			nameDescriptor: messages.useCaseCaptureMeetingNotesAndActions,
			templates: [
				{
					id: UseCaseTemplate.MeetingNotes,
					nameDescriptor: messages.useCaseTemplateMeetingNotes,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.ToDoList,
					nameDescriptor: messages.useCaseTemplateToDoList,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.ShareLegalTemplatesAndGuides,
			nameDescriptor: messages.useCaseShareLegalTemplatesAndGuides,
			templates: [
				{
					id: UseCaseTemplate.VendorAgreement,
					nameDescriptor: messages.useCaseTemplateVendorAgreement,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:vendor-agreement-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.RiskAssessment,
					nameDescriptor: messages.useCaseTemplateRiskAssessment,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:risk-assessment-blueprint',
					templateType: 'page',
				},
			],
		},
	],
	[Team.Sales]: [
		{
			id: UseCase.CreateTeamPlaybooks,
			nameDescriptor: messages.useCaseCreateTeamPlaybooks,
			templates: [
				{
					id: UseCaseTemplate.SalesPortal,
					nameDescriptor: messages.useCaseTemplateSalesPortal,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.ElevatorPitchBrainstorm,
					nameDescriptor: messages.useCaseTemplateElevatorPitchBrainstorm,
					templateId: 'elevator-pitch',
					templateType: 'whiteboard',
				},
			],
		},
		{
			id: UseCase.ManageLeadsAndDeals,
			nameDescriptor: messages.useCaseManageLeadsAndDeals,
			templates: [
				{
					id: UseCaseTemplate.SalesAccountPlanning,
					nameDescriptor: messages.useCaseTemplateSalesAccountPlanning,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.MutualActionPlan,
					nameDescriptor: messages.useCaseTemplateMutualActionPlan,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:mutual-action-plan-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.ReportProgressAndPerformance,
			nameDescriptor: messages.useCaseReportProgressAndPerformance,
			templates: [
				{
					id: UseCaseTemplate.ExecutiveBusinessReview,
					nameDescriptor: messages.useCaseTemplateExecutiveBusinessReview,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.PresenterMode,
					nameDescriptor: messages.useCaseTemplatePresenterMode,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:presenter-mode-blueprint',
					templateType: 'page',
				},
			],
		},
	],
	[Team.DataScience]: [
		{
			id: UseCase.DocumentTechSpecsAndDecisions,
			nameDescriptor: messages.useCaseDocumentTechSpecsAndDecisions,
			templates: [
				{
					id: UseCaseTemplate.Flowchart,
					nameDescriptor: messages.useCaseTemplateFlowchart,
					templateId: 'flow-chart',
					templateType: 'whiteboard',
				},
				{
					id: UseCaseTemplate.DaciDecisionDocumentation,
					nameDescriptor: messages.useCaseTemplateDaciDecisionDocumentation,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.BrainstormAndExploreIdeas,
			nameDescriptor: messages.useCaseBrainstormAndExploreIdeas,
			templates: [
				{
					id: UseCaseTemplate.Crazy8s,
					nameDescriptor: messages.useCaseTemplateCrazy8s,
					templateId: 'crazy-8s',
					templateType: 'whiteboard',
				},
				{
					id: UseCaseTemplate.BrainstormSession,
					nameDescriptor: messages.useCaseTemplateBrainstormSession,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:disrupt-brainstorming-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.PlanAndTrackProjects,
			nameDescriptor: messages.useCasePlanAndTrackProjects,
			templates: [
				{
					id: UseCaseTemplate.ProjectPlan,
					nameDescriptor: messages.useCaseTemplateProjectPlan,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.WeeklyStatusReport,
					nameDescriptor: messages.useCaseTemplateWeeklyStatusReport,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
					templateType: 'page',
				},
			],
		},
	],
	[Team.CustomerService]: [
		{
			id: UseCase.ShareHowToAndTroubleshootingDocs,
			nameDescriptor: messages.useCaseShareHowToAndTroubleshootingDocs,
			templates: [
				{
					id: UseCaseTemplate.HowToArticle,
					nameDescriptor: messages.useCaseTemplateHowToArticle,
					templateId:
						'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.TroubleshootingArticle,
					nameDescriptor: messages.useCaseTemplateTroubleshootingArticle,
					templateId:
						'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.StoreTeamProceduresAndReferences,
			nameDescriptor: messages.useCaseStoreTeamProceduresAndReferences,
			templates: [
				{
					id: UseCaseTemplate.ItsmRunbook,
					nameDescriptor: messages.useCaseTemplateItsmRunbook,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.ItsmKnownErrors,
					nameDescriptor: messages.useCaseTemplateItsmKnownErrors,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-blueprint',
					templateType: 'page',
				},
			],
		},
		{
			id: UseCase.DocumentIncidentsAndResolutions,
			nameDescriptor: messages.useCaseDocumentIncidentsAndResolutions,
			templates: [
				{
					id: UseCaseTemplate.IncidentPostmortem,
					nameDescriptor: messages.useCaseTemplateIncidentPostmortem,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-management-post-mortem-blueprint',
					templateType: 'page',
				},
				{
					id: UseCaseTemplate.WeeklyIncidentReport,
					nameDescriptor: messages.useCaseTemplateWeeklyIncidentReport,
					templateId:
						'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-weekly-major-incident-report-blueprint',
					templateType: 'page',
				},
			],
		},
	],
};

/**
 * Helper method which takes teamType as input and returns 3 use cases that contain 2 templates each
 * for the teamType
 * @param teamType A valid Team
 * @returns Array of 3 UseCaseDataTypes
 */
export const fetchUseCasesWithTemplatesForTeamType = (teamType: Team): UseCaseDataType[] => {
	return teamTypeToUseCaseMap[teamType];
};

/**
 * Helper method which takes teamType and useCases array as input and returns detailed template
 * data. The returned template data is ordered by the useCases first and then followed by all the
 * remaining templaes for the teamType.
 * @param teamType A valid Team
 * @param useCases A valid array of UseCase or an empty array.
 * @returns Detailed use case template information in an array of UseCaseTemplateDataType
 */
export const fetchUseCaseTemplatesByTempTypeAndUseCaseId = (
	teamType: Team,
	useCases: UseCase[],
): UseCaseTemplateDataType[] => {
	let useCaseTemplates: UseCaseTemplateDataType[] = [];
	let useCasesForTeamType = [...teamTypeToUseCaseMap[teamType]];

	// Add any selected Use Cases first
	for (let ucIndex = 0; ucIndex < useCases.length; ucIndex++) {
		for (let index = 0; index < useCasesForTeamType.length; index++) {
			const entry = useCasesForTeamType[index];
			if (entry.id === useCases[ucIndex] && entry.templates.length >= 2) {
				useCaseTemplates.push(entry.templates[0]);
				useCaseTemplates.push(entry.templates[1]);
				useCasesForTeamType.splice(index, 1);
			}
		}
	}

	// Add the remaining Team Type Use Cases
	for (let index = 0; index < useCasesForTeamType.length; index++) {
		const entry = useCasesForTeamType[index];
		if (entry.templates.length >= 2) {
			useCaseTemplates.push(entry.templates[0]);
			useCaseTemplates.push(entry.templates[1]);
		}
	}

	return useCaseTemplates;
};
